import React from "react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Box, IconButton } from "@mui/material";

const ShowImage = (props) => {
   return (
      <Box className="image_preview_wrapper">
         {
            props.profilePic ?
               props.profilePic && <div className="img_preview_circle">
                  <Box sx={{ position: 'absolute', top: '-8px', right: '-8px' }}>
                     <IconButton onClick={() => props.onRemoveFunc()} sx={{ padding: 0, height: '24px', width: '24px', borderRadius: '50%', backgroundColor: 'rgba(0,0,0,0.8) !important', "&:hover": { backgroundColor: '#630000 !important' } }}>
                        <CloseOutlined style={{ color: '#fff', fontSize: '16px' }} />
                     </IconButton>
                  </Box>
                  <img src={props.profilePic} alt="profile" />
               </div>
               :
               props.showImage &&
               <div className="img_preview_circle">
                  <Box sx={{ position: 'absolute', top: '-8px', right: '-8px' }}>
                     <IconButton onClick={() => props.onRemoveFunc()} sx={{ padding: 0, height: '24px', width: '24px', borderRadius: '50%', backgroundColor: 'rgba(0,0,0,0.8) !important', "&:hover": { backgroundColor: '#630000 !important' } }}>
                        <CloseOutlined style={{ color: '#fff', fontSize: '16px' }} />
                     </IconButton>
                  </Box>
                  <img src={process.env.REACT_APP_PROFILE_URL + props.folderName + props.showImage} alt="profile" />
               </div>
         }
      </Box>
   )
}

export default ShowImage